<template>
	<li :classes="classes">
		<!-- @slot Holds the list -->
		<slot />
	</li>
</template>

<script>
export default {
	props: {
		classes: {
			type: String,
			default: '',
		},
	},
};
</script>
